import { Component, HostListener } from '@angular/core';

interface GalleryImage {
    src: string;
    alt?: string;
    caption?: string;
}

@Component({
    selector: 'app-gallery-page',
    templateUrl: './gallery-page.component.html',
    styleUrls: ['./gallery-page.component.scss'],
    standalone: false,
})
export class GalleryPageComponent {
    images: GalleryImage[] = [
        { src: 'assets/images/gallery/haz_1.jpg', alt: 'Vendégház előről', caption: 'Vendégház - az utca felől' },
        { src: 'assets/images/gallery/haz_2.jpg', alt: 'Vendégház - udvar', caption: 'Vendégház - udvar' },
        { src: 'assets/images/gallery/nappali_0.jpg', alt: 'Nappalink', caption: 'Nappalink' },
        { src: 'assets/images/gallery/nappali_1.jpg', alt: 'Nappalink', caption: 'Nappalink' },
        { src: 'assets/images/gallery/nappali_2.jpg', alt: 'Nappalink', caption: 'Nappalink' },
        { src: 'assets/images/gallery/nappali_3.jpg', alt: 'Nappalink', caption: 'Nappalink' },
        { src: 'assets/images/gallery/nappali_4.jpg', alt: 'Nappalink', caption: 'Nappalink' },
        { src: 'assets/images/gallery/lepcso.jpg', alt: 'Lépcső', caption: 'Lépcső' },
        { src: 'assets/images/gallery/emelet_folyoso.jpg', alt: 'Emelet', caption: 'Emelet' },
        { src: 'assets/images/gallery/jobb_szoba_1.jpg', alt: 'Jobb oldali szoba', caption: 'Jobb oldali szoba' },
        { src: 'assets/images/gallery/jobb_szoba_2.jpg', alt: 'Jobb oldali szoba', caption: 'Jobb oldali szoba' },
        { src: 'assets/images/gallery/jobb_szoba_3.jpg', alt: 'Jobb oldali szoba', caption: 'Jobb oldali szoba' },
        { src: 'assets/images/gallery/bal_szoba_1.jpg', alt: 'Bal oldali szoba', caption: 'Bal oldali szoba' },
        { src: 'assets/images/gallery/bal_szoba_2.jpg', alt: 'Bal oldali szoba', caption: 'Bal oldali szoba' },
        { src: 'assets/images/gallery/furdo_1.jpg', alt: 'Fürdőszoba', caption: 'Fürdőszoba' },
        { src: 'assets/images/gallery/furdo_2.jpg', alt: 'Fürdőszoba', caption: 'Fürdőszoba' },
        { src: 'assets/images/gallery/furdo_3.jpg', alt: 'Fürdőszoba', caption: 'Fürdőszoba' },
        { src: 'assets/images/gallery/mosdo_1.jpg', alt: 'Emeleti mosdó', caption: 'Emeleti mosdó' },
        { src: 'assets/images/gallery/mosdo_2.jpg', alt: 'Emeleti mosdó', caption: 'Emeleti mosdó' },
        { src: 'assets/images/gallery/mosdo_3.jpg', alt: 'Emeleti mosdó', caption: 'Emeleti mosdó' },
        { src: 'assets/images/gallery/konyha_1.jpg', alt: 'Konyha', caption: 'Konyha' },
        { src: 'assets/images/gallery/konyha_2.jpg', alt: 'Konyha', caption: 'Konyha' },
        { src: 'assets/images/gallery/konyha_3.jpg', alt: 'Konyha', caption: 'Konyha' },
        { src: 'assets/images/gallery/konyha_4.jpg', alt: 'Konyha', caption: 'Konyha' },
        { src: 'assets/images/gallery/terasz_1.jpg', alt: 'Terasz', caption: 'Terasz' },
        { src: 'assets/images/gallery/to_1.jpg', alt: '5-ös tó', caption: '5-ös (horgász) tó' },
    ];

    selectedIndex: number | null = null;

    get selectedImage(): GalleryImage | null {
        return this.selectedIndex != null ? this.images[this.selectedIndex] : null;
    }


    open(index: number): void {
        this.selectedIndex = index;
        if (typeof document !== 'undefined' && document && document.body) {
            document.body.style.overflow = 'hidden';
        }
    }

    close(): void {
        this.selectedIndex = null;
        if (typeof document !== 'undefined' && document && document.body) {
            document.body.style.overflow = '';
        }
    }

    next(): void {
        if (this.selectedIndex == null) return;
        this.changeTo((this.selectedIndex + 1) % this.images.length);
    }

    prev(): void {
        if (this.selectedIndex == null) return;
        this.changeTo((this.selectedIndex - 1 + this.images.length) % this.images.length);
    }

    // Touch / swipe handling for mobile
    private touchStartX: number | null = null;
    private touchStartY: number | null = null;
    private touchMoved = false;
    private lastWasSwipe = false;

    onTouchStart(e: TouchEvent): void {
        const t = e.touches && e.touches[0];
        if (!t) return;
        this.touchStartX = t.clientX;
        this.touchStartY = t.clientY;
        this.touchMoved = false;
    }

    onTouchMove(e: TouchEvent): void {
        if (this.touchStartX == null) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        const dx = t.clientX - this.touchStartX;
        const dy = t.clientY - this.touchStartY!;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
            e.preventDefault();
            this.touchMoved = true;
        }
    }

    onTouchEnd(e: TouchEvent): void {
        if (this.touchStartX == null) return;
        const t = e.changedTouches && e.changedTouches[0];
        const endX = t ? t.clientX : null;
        const endY = t ? t.clientY : null;
        const dx = endX != null ? endX - this.touchStartX : 0;
        const dy = endY != null && this.touchStartY != null ? endY - this.touchStartY : 0;
        const threshold = 50; // px
        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
            // It's a horizontal swipe: navigate and mark that a swipe occurred.
            if (dx < 0) this.next();
            else this.prev();
            this.lastWasSwipe = true;
            // Keep `lastWasSwipe` true briefly so the following click (which some browsers fire)
            // doesn't close the lightbox. Clear after 300ms.
            setTimeout(() => { this.lastWasSwipe = false; }, 300);
        }
        this.touchStartX = null;
        this.touchStartY = null;
        this.touchMoved = false;
    }

    /** Close the lightbox when clicking the slider area (but ignore clicks that are part of a swipe). */
    onSliderClick(e: Event): void {
        // If a swipe movement just happened, don't treat this click as a close action
        if (this.touchMoved || this.lastWasSwipe) {
            e.stopPropagation();
            return;
        }
        // otherwise close (this allows mouse clicks on PC to close the lightbox)
        this.close();
    }

    onImageClick(event: MouseEvent | TouchEvent): void {
        event.stopPropagation();
            return;
    }
    /** Instantly switch to a specific index (no animation). */
    changeTo(newIndex: number): void {
        if (this.selectedIndex == null || newIndex === this.selectedIndex) return;
        this.selectedIndex = newIndex;
        // Clear any staged indices (not used when no animation)
        // incomingIndex and animationDirection were removed
    }

    trackByIndex(_: number): number {
        return _;
    }

    /** Return a thumbnail path for a given original image path.
     * If thumbs are not generated yet, the img onerror handler will fallback to the original.
     */
    getThumbPath(original: string): string {
        try {
            const parts = original.split('/');
            const file = parts[parts.length - 1];
            const name = file.replace(/\.[^.]+$/, '');
            return `assets/images/gallery/thumbs/${name}-thumb.jpg`;
        } catch (e) {
            return original;
        }
    }

    onThumbError(event: Event, original: string): void {
        const target = event.target as HTMLImageElement;
        if (target && target.src) {
            target.src = original;
        }
    }

    @HostListener('window:keydown', ['$event'])
    handleKeydown(event: KeyboardEvent): void {
        if (this.selectedIndex == null) return;
        if (event.key === 'Escape') this.close();
        else if (event.key === 'ArrowRight') this.next();
        else if (event.key === 'ArrowLeft') this.prev();
    }
}